import React from 'react';
import PropTypes from 'prop-types';
import { faAngleDown, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const CollapseIndicator = ({open}) => (
    <FontAwesomeIcon
        className='switch-icon'
        icon={open ? faAngleDown : faAngleRight}
        fixedWidth={true}
    />
);

CollapseIndicator.propTypes = {
    /** Whether to indicate an open or closed state */
    open: PropTypes.bool.isRequired,
};

export default CollapseIndicator;



// WEBPACK FOOTER //
// ./src/components/indicators/collapse-indicator.js